import React, { createContext, useContext } from 'react'
import { courseStore } from '../../state/courseStore'
import flattenMessages from '../../utils/flattenMessages'
import messages from '../../translations/export'
import { IntlProvider } from 'react-intl'

export const LangContext = createContext()

export default ({ children, course }) => {
  const { state: courseState } = useContext(courseStore)
  const language = courseState.language
  return (
    <LangContext.Provider value={{ language }}>
      <IntlProvider
        locale={language}
        messages={flattenMessages(messages[language])}
      >
        {children}
      </IntlProvider>
    </LangContext.Provider>
  )
}
